if (!customElements.get('jp-post-delivery-time')) {
  customElements.define(
    'jp-post-delivery-time',
    class JpPostDeliveryTime extends HTMLElement {
      constructor() {
        super();
        
        this.select = this.querySelector('select');
        this.debounceTimer = null;
        this.currentValue = '';
        this.isRequired = this.dataset.required === 'true';
        
        // Get checkout buttons
        this.checkoutButtons = this.getCheckoutButtons();
        
        // Get saved value from cart attributes if exists
        this.loadSavedValue();
        
        // Setup event listener
        if (this.select) {
          this.select.addEventListener('change', this.handleChange.bind(this));
        }
        
        // Initial validation
        this.validateCheckoutButtons();
      }
      
      getCheckoutButtons() {
        const buttons = [];
        // Main cart checkout button
        const mainCheckout = document.getElementById('checkout');
        if (mainCheckout) buttons.push(mainCheckout);
        
        // Cart drawer checkout button
        const drawerCheckout = document.getElementById('CartDrawer-Checkout');
        if (drawerCheckout) buttons.push(drawerCheckout);
        
        return buttons;
      }
      
      validateCheckoutButtons() {
        if (!this.isRequired) return;
        
        const hasValidSelection = this.currentValue && this.currentValue !== '';
        
        this.checkoutButtons.forEach(button => {
          if (hasValidSelection) {
            button.disabled = false;
            button.classList.remove('jp-post-delivery__disabled');
            // Remove any tooltip
            button.removeAttribute('title');
          } else {
            button.disabled = true;
            button.classList.add('jp-post-delivery__disabled');
            // Add tooltip to explain why it's disabled
            button.setAttribute('title', this.getLocalizedMessage('checkout_disabled'));
          }
        });
      }
      
      async loadSavedValue() {
        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();
          
          if (cart.attributes && cart.attributes.delivery_time) {
            this.currentValue = cart.attributes.delivery_time;
            if (this.select) {
              this.select.value = this.currentValue;
            }
          }
          
          // Validate after loading
          this.validateCheckoutButtons();
        } catch (error) {
          console.error('Error loading saved delivery time:', error);
        }
      }
      
      handleChange(event) {
        const newValue = event.target.value;
        
        // Don't update if value hasn't changed
        if (newValue === this.currentValue) {
          return;
        }
        
        // Clear existing timer
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }
        
        // Add loading state
        this.classList.add('jp-post-delivery--loading');
        
        // Debounce the update
        this.debounceTimer = setTimeout(() => {
          this.updateCartAttribute(newValue);
        }, 500);
      }
      
      async updateCartAttribute(value) {
        try {
          const formData = new FormData();
          
          // If value is empty, we still need to update to clear it
          formData.append('attributes[delivery_time]', value);
          
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            body: formData
          });
          
          if (!response.ok) {
            throw new Error('Failed to update cart');
          }
          
          const cart = await response.json();
          this.currentValue = value;
          
          // Validate checkout buttons after successful update
          this.validateCheckoutButtons();
          
          // Dispatch custom event for other components
          this.dispatchEvent(new CustomEvent('delivery-time-updated', {
            detail: { value, cart },
            bubbles: true
          }));
          
          // Remove loading state
          this.classList.remove('jp-post-delivery--loading');
          
          // Show brief success feedback
          this.showSuccessFeedback();
          
        } catch (error) {
          console.error('Error updating delivery time:', error);
          this.classList.remove('jp-post-delivery--loading');
          
          // Revert select to previous value on error
          if (this.select) {
            this.select.value = this.currentValue;
          }
          
          // Show error feedback
          this.showErrorFeedback();
        }
      }
      
      getLocalizedMessage(type) {
        // Get the current locale
        const locale = document.documentElement.lang || 'en';
        
        if (type === 'checkout_disabled') {
          const messages = {
            'en': 'Please select a delivery time slot to continue',
            'ja': '続行するには配達時間帯を選択してください',
            'id': 'Silakan pilih slot waktu pengiriman untuk melanjutkan',
            'my': 'ဆက်လက်လုပ်ဆောင်ရန် ပေးပို့ချိန်ကို ရွေးချယ်ပါ'
          };
          return messages[locale] || messages['en'];
        }
        
        return '';
      }
      
      showSuccessFeedback() {
        // Add success class temporarily
        this.classList.add('jp-post-delivery--success');
        
        // Remove after animation
        setTimeout(() => {
          this.classList.remove('jp-post-delivery--success');
        }, 2000);
      }
      
      showErrorFeedback() {
        // Add error class temporarily
        this.classList.add('jp-post-delivery--error');
        
        // Remove after animation
        setTimeout(() => {
          this.classList.remove('jp-post-delivery--error');
        }, 2000);
      }
      
      connectedCallback() {
        // Re-load value when element is added to DOM (e.g., after cart drawer opens)
        this.loadSavedValue();
        
        // Update checkout buttons reference in case new ones were added
        this.checkoutButtons = this.getCheckoutButtons();
        this.validateCheckoutButtons();
      }
    }
  );
}

// Listen for cart updates from other components
document.addEventListener('cart:updated', (event) => {
  const deliveryTimeComponent = document.querySelector('jp-post-delivery-time');
  if (deliveryTimeComponent && event.detail && event.detail.cart) {
    const cart = event.detail.cart;
    if (cart.attributes && cart.attributes.delivery_time !== undefined) {
      const select = deliveryTimeComponent.querySelector('select');
      if (select) {
        select.value = cart.attributes.delivery_time || '';
        deliveryTimeComponent.currentValue = cart.attributes.delivery_time || '';
      }
    }
  }
});